import * as ko from "knockout";
import ObjectDetails from "../../object/ObjectDetails";
import {IObjectData, IRouteDefinitionParams, ITableColumn, TRouteId, TSyncfield} from "../../../index";
import {_} from 'lodash';
import {getRawSyncFieldValue} from "../../../util/misc";
import {memoryStore} from "../../../util/memorystore";
import {ISortableTableParams} from "../../sortable/index";
import {ObjectTypeId} from "../../../constants";
import {global} from "../../../appContext";
import {getDate, getTime} from "../../../util/datetime";
import {setRouteHash} from "../../../constants/RouteDefinitions";
import contributors_listHtml from './contributors-list.html?raw';

export let template = contributors_listHtml;

type TType = 'formdata' | 'members';

interface IParams {
    type: TType
}

interface IProperties {
    attributeName: TType,
    placeholder: string,
    table: ITableColumn<IObjectData>[]
}

export class viewModel extends ObjectDetails {

    private readonly tableData: KnockoutObservableArray<IObjectData> = ko.observableArray<IObjectData>([]);
    private readonly searchkey: KnockoutObservable<string | null> = ko.observable(null);
    private readonly sortcol: KnockoutObservable<keyof IObjectData> = memoryStore.get("group.members.sortcolumn", "GivenName");
    private readonly sortdirection: KnockoutObservable<boolean> = memoryStore.get("group.members.direction", true);

    private readonly table: ITableColumn<IObjectData>[];
    private props: IProperties;

    private tableParams: ISortableTableParams<IObjectData>;

    constructor(protected params: IRouteDefinitionParams & IParams) {
        super(params, false);
        switch (params.type) {
            case "formdata":
                this.props = {
                    attributeName: 'formdata',
                    placeholder: 'search|td',
                    table: [
                        {
                            label: "id",
                            key: "id",
                            sort: true,
                        },
                        {
                            label: "form id",
                            key: "FormId",
                            sort: true,
                        },
                        {
                            label: "((form)) ((name))",
                            key: "FormName",
                            sort: true,
                        },
                        {
                            label: "created",
                            key: "Created",
                            sort: true,
                        },
                        {
                            label: "approved",
                            key: "ApprovedDate",
                            sort: true,
                        },
                        {
                            label: "rejected",
                            key: "RejectedDate",
                            sort: true,
                        },
                    ]
                }
                break;
            case "members":
                this.props = {
                    attributeName: 'members',
                    placeholder: 'search|td',
                    table: [
                        {
                            label: "id",
                            key: "id",
                            sort: true,
                        },
                        {
                            label: "givenname",
                            key: "GivenName",
                            sort: true,
                        },
                        {
                            label: "surname",
                            key: "Surname",
                            sort: true,
                        },
                        {
                            label: "employee number",
                            key: "EmployeeNumber",
                            sort: true,
                        },
                        {
                            label: "relation type",
                            key: "relationtype",
                            sort: true,
                        },
                        {
                            label: "relation name",
                            key: "relationtypename",
                            sort: true,
                        },
                    ]
                }
                break;
        }

        this.table = this.props.table;

        this.tableParams = {
            TABLE: this.table,
            data: this.dataFiltered,
            route: "user",
            sortcol: this.sortcol,
            asc: this.sortdirection,
            getCellContent: this.getCellContent.bind(this),
            getCellText: this.getCellText.bind(this),
            onRowClick: this.onRowClick.bind(this),
        };

        this.request();
    }

    protected override onSuccess(data: [IObjectData]): Promise<[IObjectData]> {
        data = _.cloneDeep(data);
        this.data(data[0]);
        const tableData = this.data()?.[this.props.attributeName] || [];
        this.tableData(tableData);
        this.messageData(null);
        this.isReady(true);
        return Promise.resolve(data);
    }


    private dataFiltered = ko.pureComputed(() => {
        if (this.searchkey()) {
            return this.tableData().filter((item: IObjectData) => {
                return this.table.find((col: ITableColumn<IObjectData>): boolean => {
                    const str = String(this.getCellText(col.key, null, item)).toLowerCase();
                    return str.indexOf(this.searchkey()?.toLowerCase() ?? '') > -1
                });
            });
        } else {
            return this.tableData();
        }
    });

    getCellContent(key: string, val: any, item: IObjectData) {
        let str = this.getCellText(key, val, item);

        if (this.searchkey()) {
            let regex = new RegExp(this.searchkey()!.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'gi');
            str = String(str).replace(regex, (match) => {
                return "<mark>" + match + "</mark>";
            });
        }

        return str;
    }

    getCellText(key: string, val: any, item: IObjectData) {
        switch (key) {
            case "Created":
            case "ApprovedDate":
            case "RejectedDate": {
                const syncfieldValue = getRawSyncFieldValue(key as TSyncfield, item.syncfields)
                if (syncfieldValue) {
                    return `${getDate(syncfieldValue, true)} ${getTime(syncfieldValue, true)}`
                } else {
                    return '—'
                }
            }
        }
        // is it an object's key?
        if (key in item) {
            return String(item[key as keyof IObjectData] ?? '');
        }
        // ...or a syncfield key?
        return String(getRawSyncFieldValue(key as TSyncfield, item.syncfields) ?? '');
    }

    private onRowClick(obj: IObjectData): boolean {
        global.login.setSelectedOrganizationById(obj.orgnr);
        let routeId: TRouteId

        // todo: look at this
        switch (obj.type?.id) {
            case ObjectTypeId.FormData:
                routeId = `formdata`;
                break;
            case ObjectTypeId.ExternalContact:
                routeId = `_externalcontact`;
                break;
            default:
                routeId = `userdetails`;
                break;
        }
        setRouteHash(routeId, {id: obj.id})
        return true;
    }

}
